const power = {
    state: {
        powerListDisplay: false, //false为不显示router-view 1为显示 
        userListDisplay:false
    },
    mutations: {
        showPowerList(state) {
            state.powerListDisplay = true
        },
        hidePowerList(state) {
            state.powerListDisplay = false
        },
        showUserList(state) {
            state.userListDisplay = true
        },
        hideUserList(state) {
            state.userListDisplay = false
        }
    }
}

export default power